import axios from "axios";
import { saveAs } from "file-saver";

import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

// [VinUni] Quản lý đề tài

const meta = (phase) => ({ prefix: [PREFIX.RESEARCH_TOPIC, phase] });

// ---- Đọc dữ liệu ----

export const filterTopics = (payload = {}, page = 1, pageSize = -1) => async (dispatch) => {
  const api = API_URLS.RESEARCH_TOPIC.filter(page, pageSize);
  dispatch({ type: TYPE.RESEARCH_TOPIC.FILTER_LOADING, meta: meta(PREFIX.API_CALLING) });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_TOPIC.FILTER_SUCCESS,
      payload: response.data.data,
      total: response.data.metaData ? response.data.metaData.total : 0,
      meta: meta(PREFIX.API_SUCCESS),
    });
  } else {
    dispatch({ type: TYPE.RESEARCH_TOPIC.FILTER_FAILURE, meta: meta(PREFIX.API_FAILURE) });
    dispatch(notification({ type: "error", message: "Lấy danh sách đề tài thất bại!" }));
  }
};

export const getTopicById = (id) => async (dispatch) => {
  const api = API_URLS.RESEARCH_TOPIC.getById(id);
  dispatch({ type: TYPE.RESEARCH_TOPIC.GET_BY_ID_LOADING, meta: meta(PREFIX.API_CALLING) });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_TOPIC.GET_BY_ID_SUCCESS,
      payload: response.data.data,
      meta: meta(PREFIX.API_SUCCESS),
    });
  } else {
    dispatch({ type: TYPE.RESEARCH_TOPIC.GET_BY_ID_FAILURE, meta: meta(PREFIX.API_FAILURE) });
  }
};

export const getDashboard = (profileId) => async (dispatch) => {
  const api = API_URLS.RESEARCH_TOPIC.dashboard(profileId);
  dispatch({ type: TYPE.RESEARCH_TOPIC.DASHBOARD_LOADING, meta: meta(PREFIX.API_CALLING) });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_TOPIC.DASHBOARD_SUCCESS,
      payload: response.data.data,
      meta: meta(PREFIX.API_SUCCESS),
    });
  } else {
    dispatch({ type: TYPE.RESEARCH_TOPIC.DASHBOARD_FAILURE, meta: meta(PREFIX.API_FAILURE) });
  }
};

// ---- Ghi dữ liệu (kèm refetch) ----

// runMutation: chạy 1 lời gọi ghi, hiện thông báo, refetch list nếu thành công.
const runMutation = (api, payload, okMsg, errMsg, reloadPayload) => async (dispatch) => {
  dispatch({ type: TYPE.RESEARCH_TOPIC.SUBMITTING_LOADING, meta: meta(PREFIX.API_CALLING) });
  const { response, error } = await apiCall({ ...api, payload });
  dispatch({ type: TYPE.RESEARCH_TOPIC.SUBMITTING_DONE, meta: meta(PREFIX.API_SUCCESS) });
  if (!error && response.status === 200 && response.data.success) {
    if (okMsg) dispatch(notification({ type: "success", message: okMsg }));
    if (reloadPayload !== undefined) dispatch(filterTopics(reloadPayload));
    return { success: true, data: response.data.data };
  }
  const serverMsg = response && response.data ? response.data.message : "";
  dispatch(notification({ type: "error", message: serverMsg || errMsg }));
  return { success: false, message: serverMsg };
};

export const insertTopic = (payload, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.insert(), payload, "Thêm đề tài thành công!", "Thêm đề tài thất bại!", reloadPayload));

export const updateTopic = (id, payload, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.update(id), payload, "Cập nhật đề tài thành công!", "Cập nhật đề tài thất bại!", reloadPayload));

export const deleteTopic = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.delete(id), null, "Xoá đề tài thành công!", "Xoá đề tài thất bại!", reloadPayload));

export const submitTopic = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.submit(id), null, "Nộp đề tài thành công!", "Nộp đề tài thất bại!", reloadPayload));

export const approveTopic = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.approve(id), null, "Đã duyệt đề tài, bắt đầu thực hiện!", "Duyệt đề tài thất bại!", reloadPayload));

export const returnTopicToDraft = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.returnToDraft(id), null, "Đã trả về chỉnh sửa!", "Thao tác thất bại!", reloadPayload));

export const resumeTopic = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.resume(id), null, "Đề tài tiếp tục thực hiện!", "Thao tác thất bại!", reloadPayload));

export const changeStatus = (id, status, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.changeStatus(id), { status }, "Cập nhật trạng thái thành công!", "Cập nhật trạng thái thất bại!", reloadPayload));

export const closeTopic = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.close(id), null, "Đóng đề tài thành công!", "Đóng đề tài thất bại!", reloadPayload));

export const requestAcceptance = (id, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.requestAcceptance(id), null, "Đã chuyển sang chờ nghiệm thu!", "Thao tác thất bại!", reloadPayload));

export const setAcceptance = (id, payload, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.setAcceptance(id), payload, "Cập nhật kết quả nghiệm thu thành công!", "Thao tác thất bại!", reloadPayload));

export const addProgressReport = (id, payload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.addProgressReport(id), payload, "Thêm báo cáo tiến độ thành công!", "Thao tác thất bại!"));

export const requestExtension = (id, payload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.requestExtension(id), payload, "Gửi yêu cầu gia hạn thành công!", "Thao tác thất bại!"));

export const approveExtension = (extId, approve) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.approveExtension(extId, approve), null, "Đã xử lý yêu cầu gia hạn!", "Thao tác thất bại!"));

export const requestStop = (id, payload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.requestStop(id), payload, "Gửi yêu cầu dừng thành công!", "Thao tác thất bại!"));

export const approveStop = (reqId, approve, reloadPayload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.approveStop(reqId, approve), null, "Đã xử lý yêu cầu dừng!", "Thao tác thất bại!", reloadPayload));

export const sendTopicEmail = (payload) => (dispatch) =>
  dispatch(runMutation(API_URLS.RESEARCH_TOPIC.sendEmail(), payload, "Gửi email thành công!", "Gửi email thất bại!"));

// Xuất báo cáo thống kê ra Excel (mục 9). Dùng axios trực tiếp để nhận blob.
export const exportStatistics = (payload = {}) => async (dispatch) => {
  const api = API_URLS.RESEARCH_TOPIC.exportStatistics();
  try {
    const res = await axios({ url: api.endPoint, method: api.method, data: payload, responseType: "blob" });
    saveAs(new Blob([res.data]), "bao-cao-de-tai.xlsx");
  } catch (e) {
    dispatch(notification({ type: "error", message: "Xuất báo cáo thất bại!" }));
  }
};
